// 新聞標籤區塊
import Tag from "../layout/Tag";

const NewsTags = ({ tags }) => {
  return (
    <div className="flex items-center justify-start gap-x-[6px] gap-y-[12px] my-[20px] flex-wrap">
      {tags?.map((tag) => (
        //   標籤
        <Tag key={"news-tag" + tag} tag={tag}>
          ＃{tag}
        </Tag>
      ))}
    </div>
  );
};

export default NewsTags;
